import { Field, useFormikContext } from "formik";
import React, { FC, useEffect } from "react";
import { ACCOUNT_TYPES } from "../../../constants/account-constants";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { validateEmail } from "../../../utilities/Validation";
import Label from "../../label/label";
import { MobileAccount } from "../../../models/Account";

interface CaptureEmailProps {
    userEmail: string;
    account: MobileAccount | undefined,
    onBack: (event: any) => void;
    onNext: (event: any) => void;
}

const CaptureEmail: FC<CaptureEmailProps> = ({ onBack, userEmail, onNext, account }) => {
    const { translate } = useLocale();
    const { errors, setFieldValue } = useFormikContext<any>();

    useEffect(() => {
        setFieldValue('userEmail', userEmail);
        setFieldValue('accountType', account?.accountTypeId);
    }, [account, userEmail])

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <p className="text-sm mb-2">{account?.accountTypeId == ACCOUNT_TYPES.ID_HID_MOBILE_ACCESS.toString() ? translate.byKey(TranslationKeys.mobileAccessSummaryMessage) : translate.byKey(TranslationKeys.mobileStidSummaryMessage)}</p>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="userEmail"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.email)}:</Label>
                    {errors.userEmail ? <span className='text-red-600 text-xs'>{errors.userEmail}</span> : null}
                </div>
                <Field
                    name="userEmail"
                    type="email"
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                    validate={(value) => validateEmail(value, translate, true)} />
            </div>
            <div className="flex flex-col">
            </div>
        </div>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5 "
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary  ${errors.userEmail ? 'secondary-disabled cursor-not-allowed' : 'text-white bg-portal-blue-primary-shade2'}`}
                    type="button"
                    onClick={e => !errors.userEmail && onNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default CaptureEmail;